export const COLOR_1 = "#000";
export const COLOR_2 = "var(--primaryColor)";
export const COLOR_3 = "lightgray";
export const COLOR_4 = "#FFF";
export const COLOR_5 = "#e66da5";

export const COLOR_6 = "#44acf8";
export const COLOR_7 = "#fcd647";
export const COLOR_8 = "#cecece";
export const COLOR_9 = "#8400FF";

export const COLOR_10 = "rgba(230, 109, 165, .05)";
export const COLOR_11 = "rgba(68, 172, 248, .05)";
export const COLOR_12 = "rgba(252, 214, 71, .10)";

export const COLOR_COURSE_ONLINE = COLOR_5;
export const COLOR_COURSE_ONLINE_BACKGROUND = COLOR_10;
export const COLOR_COURSE_CLASSROOM = COLOR_6;
export const COLOR_COURSE_CLASSROOM_BACKGROUND = COLOR_11;
export const COLOR_COURSE_ACTIVITY = COLOR_7;
export const COLOR_COURSE_ACTIVITY_BACKGROUND = COLOR_12;
export const COLOR_PROGRAM = COLOR_9;

export const COLOR_PROGRESS_BG = "#efefef";
export const COLOR_BADGE = "#007BC6";
export const COLOR_BADGE_BG = "#DDD";
export const COLOR_BADGE_SELECTED = "#DDD";
export const COLOR_BADGE_SELECTED_BG = "#007BC6";

export const COURSE_TYPE_ONLINE = "Online";
export const COURSE_TYPE_CLASSROOM = "Classroom";
export const COURSE_TYPE_ACTIVITY = "Activity";
export const COURSE_TYPE_COMMON_ACTIVITY = "CommonActivity";
export const COURSE_TYPE_NEW_COMMON_ACTIVITY = "NewCommonActivity";
export const COURSE_TYPE_PROGRAM = "Program";
export const COURSE_TYPE_SURVEY_TO_COMPLETE = "SurveyToComplete";

export const ACTIVITY_TYPE_INTERNAL = "internalcourse";
export const ACTIVITY_TYPE_OTHER = "otheractivity";
export const ACTIVITY_TYPE_EXTERNAL = "externalcourse";
export const ACTIVITY_TYPE_PROGRAM_OTHER = "programotheractivity";
export const ACTIVITY_TYPE_PROGRAM_COMMON = "programcommonactivity";

export const COURSE_COLOR_PROGRESS_NEUTRAL = COLOR_8;
export const COURSE_COLOR_PROGRESS_LOW = "red";
export const COURSE_COLOR_PROGRESS_MEDIUM = "#eabd3c";
export const COURSE_COLOR_PROGRESS_HIGH = "#007702";

export const ICON_SIZE = 20;

export const PROGRESS_ALL = "ALL";
export const PROGRESS_TODO = "TODO";
export const PROGRESS_DONE = "DONE";
export const PROGRESS_ONGOING = "ONGOING";

export const SYSTEM_SETTING_SHOW_COURSE_IMAGE_PORTAL =
  "showcourseimageinportal";
export const SYSTEM_SETTING_ON = "1";

export const PROGRAM_ICON_CLASS = "fa fa-graduation-cap";
export const PROGRAM_ACTIVITY_IMAGE = "./Content/img/neutral.jpg"; //"./Content/img/activity.jpg";
export const PROGRAM_COURSE_IMAGE = "./Content/img/neutral.jpg";
export const PROGRAM_COURSE_IMAGE_BLANK = "./Content/img/blank.gif";
export const PROGRAM_COURSE_IMAGE_BLANK_PORTALOVERVIEW =
  "../Content/img/blank.gif";
export const PROGRAM_IMAGE = "./Content/img/program.png";
export const PROGRAM_IMAGE_PORTALOVERVIEW = "../Content/img/program.png";
export const PROGRAM_COURSE_IMAGE_PORTALOVERVIEW = "../Content/img/neutral.jpg";
export const PROGRAM_SURVEY_IMAGE = "./Content/img/programStepSurvey.jpg";

export const OBJECT_TYPE_ONLINE = 4;
export const OBJECT_TYPE_CLASSROOM = 5;

export const ATTEST_WAITING = 0;
